import {
  AnthropicIcon as AnthropicMono, GrokIcon as GrokMono, Groq as GroqMono, Nvidia as NvidiaMono,
  OllamaIcon as OllamaMono, OpenaiIcon as OpenaiMono, Xai as XaiMono,
} from '@dev.icons/react/mono';
import {
  AwsBedrockIcon, ClaudeIcon, CloudflareIcon, CloudflareWorkersIcon, Deepseek, GoogleGeminiIcon,
  MetaIcon, MicrosoftAzure, MistralAiIcon, Perplexity, Stripe, WhatsappIcon, CohereIcon,
} from '@dev.icons/react';
import { ICONS } from './ui/icons';

/**
 * Logos de provedores e modelos (devicons.io, MIT). Logos pretas usam a
 * versão monocromática (cor do texto), para aparecerem também no tema escuro.
 */
type Logo = typeof OpenaiMono;

const LOGOS: Record<string, Logo> = {
  openai: OpenaiMono,
  anthropic: AnthropicMono,
  claude: ClaudeIcon,
  gemini: GoogleGeminiIcon,
  google: GoogleGeminiIcon,
  groq: GroqMono,
  ollama: OllamaMono,
  cloudflare: CloudflareIcon,
  'cloudflare-workers': CloudflareWorkersIcon,
  deepseek: Deepseek,
  mistral: MistralAiIcon,
  meta: MetaIcon,
  xai: XaiMono,
  grok: GrokMono,
  nvidia: NvidiaMono,
  cohere: CohereIcon,
  perplexity: Perplexity,
  bedrock: AwsBedrockIcon,
  azure: MicrosoftAzure,
  whatsapp: WhatsappIcon,
  stripe: Stripe,
};

/**
 * O `Icon` do Cloudscape trabalha com tamanhos nomeados; o logo usava pixels.
 * Conversão para o tamanho nomeado mais próximo.
 */

/** Fabricante pelo nome do modelo (ex.: "@cf/meta/llama-3.3" → meta, "gpt-4.1-mini" → openai) */
export function modelVendor(model: string | null | undefined): string | null {
  const m = (model || '').toLowerCase();
  if (!m) return null;
  const rules: Array<[RegExp, string]> = [
    [/claude/, 'claude'], [/\bgpt|\bo[134]-|openai|whisper/, 'openai'], [/gemini|gemma|palm/, 'gemini'],
    [/llama|meta\//, 'meta'], [/mistral|mixtral|codestral|magistral/, 'mistral'], [/deepseek/, 'deepseek'],
    [/grok/, 'grok'], [/command|cohere/, 'cohere'], [/sonar|perplexity/, 'perplexity'], [/nemotron|nvidia/, 'nvidia'],
  ];
  return rules.find(([re]) => re.test(m))?.[1] ?? null;
}

/** Logo do provedor (id da plataforma, ex.: "groq", "cloudflare"); sem logo conhecida, um ícone genérico */
export function ProviderLogo({ id, size = 20, className }: { id: string | null | undefined; size?: number; className?: string }) {
  const L = id ? LOGOS[id.toLowerCase()] : undefined;
  if (!L) return <ICONS.Sparkle size={16} />;
  return <L size={size} className={className} aria-hidden />;
}
